import { Link, Outlet, useNavigation } from 'react-router-dom';

export const Layout = (): JSX.Element => {
  const navigation = useNavigation();
  const isLoading = navigation.state === 'loading';

  return (
    <div
      style={{
        fontFamily: 'system-ui, sans-serif',
        maxWidth: 960,
        margin: '0 auto',
        padding: '24px',
      }}
    >
      <header
        style={{
          borderBottom: '1px solid #ddd',
          paddingBottom: 16,
          marginBottom: 24,
        }}
      >
        <h1 style={{ margin: 0, fontSize: 24 }}>
          <Link to="/" style={{ color: 'inherit', textDecoration: 'none' }}>
            frontend (React + Vite SSG)
          </Link>
        </h1>
        {isLoading && <p style={{ color: '#888', fontSize: 12 }}>Loading…</p>}
      </header>
      <main>
        <Outlet />
      </main>
    </div>
  );
};
